module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<ul class="sidebar-menu" data-widget="tree">\r\n    ';
  _.each(options, function(option){
 
        
        // OCULTAR EL ITEM HOME X EL MOMENTO
        if(option.item != "HOME" ){ 
  
            var liIcon = 'fa fa-th';
            switch(option.item) {
                case 'USERS':
                    liIcon = 'fa fa-user';
                    break;
                case 'ENVIRO':
                    liIcon = 'fa fa-bookmark';
                    break;
                case 'LISTS':
                    liIcon = 'fa fa-list-alt';
                    break;
                case 'LOGS':
                    liIcon = 'fa fa-archive';
                    break;
                case 'REPORT':
                    liIcon = 'fa fa-file-text-o';
                    break;
                case 'IMPORT':
                    liIcon = 'fa fa-cloud-upload';
                    break;
                case 'MASTERS':
                    liIcon = 'fa fa-cog';
                    break;                    
                case 'A_FUNC':
                    liIcon = 'fa fa-copy';
                    break; 
                default:
                    liIcon = 'glyphicon glyphicon-th-list';
            }
                   
            if(option.parent === "0") {

                // var visible = parseInt(option.visible)?'':'style="display: none"';                
                var visible = "";
                var optionText = lang[option.item];
    
                if(_.size(option.children)){

                    print('<li class="treeview" id="option' + option.id + '" ' + visible + '>' + 
                            '<a href="#" id="' + option.item +'">' + 
                                '<i class="' + liIcon + '"></i> <span>' + optionText + '</span>' +
                            '<span class="pull-right-container"><i class="fa fa-angle-left pull-right"></i></span>' + 
                            '</a><ul class="treeview-menu">');

                    var slugId = true; 
                    switch(option.item) {
                        case 'REPORT':                            
                            slugId = false;
                            break; 
                        case 'MASTERS':                            
                            slugId = false;
                            break; 
                        default:                        
                    }                       
                    
                    for(var i in option.children){
                        var childOption = option.children[i];
                        var childText = lang[childOption.item];
                        if(slugId){
                            var childItemSlug = childOption.item.split('_')[0]
                            var childItem =  childItemSlug + "_" + childOption.id;
                            var childLink =  childItemSlug.toLowerCase() + "/" + childOption.id;
                        } else {                                
                            var childItem =  childOption.item;
                            var childLink =  childOption.item.toLowerCase().replace("_", "/");
                        }
                        if(_.size(childOption.children)){

                            print('<li class="treeview">' + 
                                '<a href="#" id="' + childItem +'" parent="' + childOption.parent +'">' + 
                                '<i class="fa fa-circle-o"></i> ' + childText + 
                                '<span class="pull-right-container"><i class="fa fa-angle-left pull-right"></i></span>' + 
                                '</a><ul class="treeview-menu">');
                            for(var j in childOption.children){
                                childOption.children[j].id = parseInt(childOption.children[j].id);
                            }
                            
                            var areas = _.sortBy(childOption.children,"id");


                            for(var j=0; j < _.size(areas);j++){
                                var subOption = areas[j];
                                var subText = lang[subOption.item];                                        
                                var subItemSlug = subOption.item.split('_')[0]
                                var subItem =  subItemSlug + "_" + subOption.id;
                                var subLink =  subItemSlug.toLowerCase() + "/" + subOption.id;

                                
                                

                                if (subItemSlug !== "PLANOS")
                                    print('<li><a href="#search/' + subItem +'" id="' + subItem +'" >' + 
                                        '<i class="fa fa-circle-o"></i> ' + subText + '</a></li>');
                                else
                                    print('<li><a href="#planos/'+ subItem.toLowerCase() +'" id="' + subItem +'" >' + 
                                        '<i class="fa fa-circle-o"></i> ' + subText + '</a></li>');
                            }
                            print('</ul></li>')
                        } else {
                           print('<li>' + 
                                '<a href="#' + childLink +'" id="' + childItem +'">' + 
                                '<i class="fa fa-circle-o"></i> ' + childText + '</a></li>');
                                
                        }
                    } 
                    print('</ul></li>');
                    
                }else{ 
                    print('<li><a href="#' + option.item.toLowerCase() +'" id="' + option.item +'">'+
                            '<i class="'+ liIcon +'"></i><span> ' + optionText + '</span></a></li>');
                }
            }
        }
    });

__p+='\r\n\r\n\r\n        <div style="  display: inline-block;\r\n    width: 100%;\r\n    color: white;\r\n    font-size: 14px;\r\n    padding-left: 4px;\r\n    padding-right: 3px;\r\n    line-height: 20px;\r\n    background: #ECF0F5; \r\n    margin-top: 50px;\r\n \r\n    position: relative;" class="info_soport">\r\n            <p style="     text-align: center;\r\n    color:#222D32;\r\n    margin-top: 6px; " class="lin_hel"><i class="fa fa-info-circle" aria-hidden="true"></i> <b>¿Necesita ayuda?</b></p>\r\n            <p style="       text-align: center;     color: #222D32;\r\n    padding-bottom: 8px;\r\n    margin-bottom: 6px; " class="line_2">Envíenos un correo electrónico a <a style="     color: #222D32;\r\n    font-weight: bold; " href="mailto:soporte@coreinvent.es">soporte@coreinvent.es</a></p>\r\n\r\n        </div>\r\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/navbar/sidebarView.ejs
// module id = 433
// module chunks = 0